import { Component, OnInit, ViewChild} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { AboutService } from './about.service';
import { ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { MessageService } from '../core/services/message.service';

@Component( {
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: [ './about.component.scss' ]
} )
export class AboutComponent implements OnInit {

  @ViewChild('content') content;
  @ViewChild('name') name;
  @ViewChild('email') email;
  @ViewChild('phone') phone;
  @ViewChild('qq') qq;
  display: boolean = false;
  formData: any = {};
  advice: any = {}; //建议
  type: any; //选择的标签
  constructor(
    private _service: AboutService,
    private _msg: MessageService,
    private _route: ActivatedRoute,
    private _title: Title,
    private _meta: Meta

  ) {
    this._title.setTitle( 'X直聘-关于我们' );
    this._meta.updateTag( { name: 'Keywords', content: 'C实习,大学生实习,个人简历模板,求职就业,职业规划，就业证明，实习报告告怎么写' } );
    this._meta.updateTag( {
      name: 'Description',
      content: `C实习是国内专注于泛商科类相关专业的在线教育+求职平台。通过职业评测，
      实训课程，实战任务，电商 大赛，等 方式不断提 高学 生能 力力，获得相应的技术勋章，
      完成能 力力认证。同时帮助 大学实习 生做好，职业规划，技能再提升，实习报告，实习 心得，个 人简历制作，求职就业等服务。`
    } );
  }

  ngOnInit() {
    //获取内容
    this._route.params.subscribe(( params: Params ) => {
         this.type = params['type'];
    } );

    this._route.params.switchMap(( params: Params ) => this._service.getSiteContent( +params[ 'type' ] ) )
      .subscribe( data => {
        this.advice = data[ 'data' ];
      } );
  }

  // 获取内容
  getadvice( num: any ) {
    this._service.getSiteContent( num ).then( data => {
      this.advice = data[ 'data' ];
    } );
  }
  // 关于我们
  aboutus( num: any ) {
    this.type = num;
    this.getadvice( num );

  }

  //联系我们
  contactus( num: any ) {
    this.type = num;
    this.getadvice( num );
  }

  //企业入驻
  enterus( num: any ) {
    this.type = num;
    this.getadvice( num );
  }


    //意见反馈弹出模态框
    adviceModal(num: any) {
      this.type = num;
      this.formData = {};
      this.display = true;

    }

    // 提交意见反馈
    saveadvice() {
      if ( !this.content.valid ) {
        this._msg.info( "请输入正确的反馈意见" );
        setTimeout(() => {
          this._msg.clear();
        }, 3000 ); return false;
      } else if ( !this.name.valid ) {
        this._msg.info( "请输入正确的姓名" );
        setTimeout(() => {
          this._msg.clear();
        }, 3000 ); return false;
      } else if ( !this.email.valid ) {
        this._msg.info( "请输入正确的邮箱" );
        setTimeout(() => {
          this._msg.clear();
        }, 3000 ); return false;
      } else if ( !this.phone.valid ) {
        this._msg.info( "请输入正确的手机号" );
        setTimeout(() => {
          this._msg.clear();
        }, 3000 ); return false;
      } else if ( !this.qq.valid ) {
        this._msg.info( "请输入正确的qq号" );
        setTimeout(() => {
          this._msg.clear();
        }, 3000 ); return false;
      } else {
       console.log(222);
        this._service.getFeedback( this.formData ).then( data => {
          if ( data[ 'data' ][ 'success' ] ) {
            console.log(333);
            this.display = false;
            this._msg.success( data[ 'data' ][ 'message' ] );
            setTimeout(() => {
              this._msg.clear();
            }, 3000 );
          } else {
            console.log(444);
            this.display = false;
            this._msg.success( data[ 'data' ][ 'message' ] );
            setTimeout(() => {
              this._msg.clear();
            }, 3000 );
          }

        } );

      }

    }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/about/about.component.ts